var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rose-chart"}},[_c('div',{staticClass:"rose-chart-title"},[_vm._v("人员类型分布")]),_c('div',{staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"rangepie2"}})])
}]

export { render, staticRenderFns }